module.exports = __webpack_public_path__ + "img/puzzle_c.bb5c5be9.svg";